import styled from '@emotion/styled';
import { Tip } from '../../../components';

export const GeneralTip = styled(Tip)`
  margin-top: 16px;
  margin-left: 0;
`;
